/**
 * @file
 * Topbar menu behaviors.
 */

(function () {
  'use strict';

  // Truncate menu text on mobile
  const menuTextMap = {
    'Cómo usar esta web': 'Cómo usar',
    'How to use this website': 'How to use',
  };

  // Store original text to avoid losing it
  const originalTexts = new Map();

  function truncateMenuText() {
    const isMobile = window.innerWidth < 768; // md breakpoint

    document.querySelectorAll('.topbar-region .ui-icons-menu-text').forEach((element) => {
      // Store original text on first run
      if (!originalTexts.has(element)) {
        originalTexts.set(element, element.textContent.trim());
      }

      const fullText = originalTexts.get(element);

      if (menuTextMap[fullText]) {
        element.textContent = isMobile ? menuTextMap[fullText] : fullText;
      }
    });
  }

  // Initialize - run multiple times to catch late-rendering elements
  function init() {
    truncateMenuText();
    // Run again after a short delay to catch any late-rendered elements
    setTimeout(truncateMenuText, 100);
  }

  // Run on load with multiple fallbacks
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also run when page is fully loaded (including all resources)
  window.addEventListener('load', truncateMenuText);

  // Run on resize with debounce
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(truncateMenuText, 150);
  });
})();
